import React from "react";
 import UploadSbScheduleVariationFile from "../../components/Upload/UploadSbScheduleVariationFile";

function UploadPlanFile2({ setPageHeader }) {
  setPageHeader("Upload SB Variation");
  return (
    <div>
      <UploadSbScheduleVariationFile />
      {/* <StablePrime
        url="/textapi"
        data={{ dn: "StableImage1" }}
        identity="StableImage"
      /> */}
    </div>
  );
}

export default UploadPlanFile2;
